import { fetchWrapper } from "../FetchWrapper/FetchWrapper"
import Settings from "../../utils/CarrotConfig"

const getSignature = async (redirectUrl: string) => {
  const headers = new Headers()
  headers.append("Content-Type", "application/json")

  let requestUrl = `${Settings.CARROT_BACKEND_URL}/api/v2/signature/url`
  if (!!redirectUrl) {
    requestUrl += `?redirect-url=${encodeURIComponent(redirectUrl)}`
  }

  const response = await fetchWrapper(requestUrl, {
    method: "GET",
    headers,
    credentials: "include"
  })
  return await response.text()
}

export { getSignature }
